export const Config = {
    apiLink: process.env.REACT_APP_APILINK,
    cdnLink: process.env.REACT_APP_CDNLINK,
    eventoURL: process.env.REACT_APP_APILINKEVENTO,
    basename: process.env.REACT_APP_PATH,
    menuSuperior: 151,
    menuInformacoes: 148,
    menuServicos: 150,
    menuInstitucional: 149,
};
